export default __webpack_public_path__ + "static/assets/806ef9ed3e8d033307c672ec75f24bf6.svg";